import cpf from '@/filters/cpf.js'
import cnpj from '@/filters/cnpj.js'

export default (value) => {
  if (!value) return '-'
  const cleanValue = value.replace(/[^0-9]/g, '')
  if (cleanValue.length === 11) return cpf(cleanValue)
  if (cleanValue.length === 14) return cnpj(cleanValue)
  return '-'
}
